module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/dokumenty-7a79fe84.svg";